module.exports = __webpack_public_path__ + "static/media/Deloitte_Logo.fb10d629.png";